import React, { Component } from "react";
import PropTypes from "prop-types";
import TinyMCE from "react-tinymce";
import TemplatesFormS3Browser from "./TemplatesFormS3Browser";
import * as Constants from '../constants';
import VideoTemplatesNewInline from "./VideoTemplatesNewInline";

class TemplatesFormTinyMCE extends Component {
  static propTypes = {
    getS3FilebrowserDirectory: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps != this.props) {
      return false;
    } else {
      return true;
    }
  }

  openModalInS3Modal() {
    this.child.openModal();
  }

  openModalInVideoModal() {
    this.childVideo.openModal();
  }

  insertImageUrl(file) {
    window.tinyMCE
      .get("body")
      .execCommand("mceInsertContent", false, '<img src="' + file.url + '"/>');
  }

  insertVideoLink(file) {
    window.tinyMCE
      .get("body")
      .execCommand("mceInsertContent", false, this.makeVideoLink(file));
  }

  makeVideoLink(s3_url) {
      let arr = s3_url.split("/");
      let id = arr[arr.length - 1].split('.').slice(-2)[0] ;
      let urlArr = s3_url.split(".");
      urlArr.pop();
      let url = urlArr.join('.');
      let siteDomain = this.props.site_domain;
      return "<a href='http://" + siteDomain + "/vid/" + id +"?login={{LEAD_UUID}}'><img src='" + url + ".gif'></a>";
  }

  height() {
    if (this.props.height == undefined) {
      return "450";
    } else {
      return "200";
    }
  }

  render() {
    return (
      <div>
        <TemplatesFormS3Browser
          onRef={ref => (this.child = ref)}
          getS3FilebrowserDirectory={this.props.getS3FilebrowserDirectory}
          insertImageUrl={this.insertImageUrl}
        />

        <VideoTemplatesNewInline
          onRef={ref => (this.childVideo = ref)}
          match={this.props.match}
          location={this.props.location}
          insertVideoLink={this.insertVideoLink.bind(this)}
        />

        <TinyMCE
          key="body"
          id="body"
          content={this.props.content}
          config={{
            valid_elements : "a[href|target],strong/b,div[align|style],br,p[style],img[style|src|alt|height|width],em,span[align|style],h1[style],h2[style],h3[style],h4[style],h5[style],h6[style],pre",
            setup: editor => {
              if (this.props.hideMergeFields != 'true') {
                editor.addButton("merge_fields", {
                  type: "menubutton",
                  text: "Merge Fields",
                  icon: false,
                  menu: [
                    {
                      text: "Lead - Full Name",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{NAME}}");
                      }
                    },
                    {
                      text: "Lead - First Name",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{FIRST_NAME}}");
                      }
                    },
                    {
                      text: "Lead - Last Name",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{LAST_NAME}}");
                      }
                    },
                    {
                      text: "Lead - Email Address",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{EMAIL}}");
                      }
                    },
                    {
                      text: "Lead - Phone",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{PHONE}}");
                      }
                    },
                    {
                      text: "Lead - Login Here - Link",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{LEAD_LOGIN_HERE_LINK}}");
                      }
                    },
                    {
                      text: "Lead - Average Property Price",
                      onclick: function() {
                        editor.insertContent(
                          "&nbsp;{{LEAD_AVERAGE_PROPERTY_PRICE}}"
                        );
                      }
                    },
                    {
                      text: "Lead - Download App - Link",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{LEAD_DOWNLOAD_APP_LINK}}");
                      }
                    },
                    {
                      text: "Agent - Name",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_NAME}}");
                      }
                    },
                    {
                      text: "Agent - First Name",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_FIRST_NAME}}");
                      }
                    },
                    {
                      text: "Agent - Last Name",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_LAST_NAME}}");
                      }
                    },
                    {
                      text: "Agent - Email Address",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_EMAIL}}");
                      }
                    },
                    {
                      text: "Agent - Email Signature",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_EMAIL_SIGNATURE}}");
                      }
                    },
                    {
                      text: "Agent - Direct Phone Number",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_PHONE}}");
                      }
                    },
                    {
                      text: "Agent - Office Phone Number",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_PHONE_OFFICE}}");
                      }
                    },
                    {
                      text: "Agent - Cell Phone Number",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_PHONE_CELL}}");
                      }
                    },
                    {
                      text: "Agent - Home Phone Number",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_PHONE_HOME}}");
                      }
                    },
                    {
                      text: "Agent - Profile Image",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{AGENT_PROFILE_IMAGE}}");
                      }
                    },
                    {
                      text: "Lead - Advanced Search - Link",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{LEAD_ADVANCED_SEARCH_LINK}}");
                      }
                    },
                    {
                      text: "Lead - Sold Search - Link",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{LEAD_SOLD_SEARCH_LINK}}");
                      }
                    },
                    {
                      text: "Lead - Market Report - Link",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{LEAD_MARKET_REPORT_LINK}}");
                      }
                    },
                    {
                      text: "Site",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{SITE}}");
                      }
                    },
                    {
                      text: "Day of Week",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{DAY_OF_WEEK}}");
                      }
                    },
                    {
                      text: "Current Month",
                      onclick: function() {
                        editor.insertContent("&nbsp;{{CURRENT_MONTH}}");
                      }
                    }
                  ]
                });
              }
              editor.addButton("add_video", {
                text: "Video",
                icon: "media",
                onclick: this.openModalInVideoModal.bind(this)
              });
              editor.addButton("add_image", {
                text: "",
                icon: "image",
                onclick: this.openModalInS3Modal.bind(this)
              });
            },
            height: this.height(),
            branding: false,
            plugins: "autolink link lists print preview code",
            menubar: false,
            elementpath: false,
            toolbar:
              "undo redo formatselect bold italic alignleft aligncenter alignright code link merge_fields add_image add_video"
          }}
        />
      </div>
    );
  }
}

export default TemplatesFormTinyMCE;
